import {
  Button,
  Card,
  Col,
  Form,
  Input,
  Row,
  Select,
  Table,
  Typography,
  Checkbox,
  Radio,
  Tooltip,
} from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import axios from "axios";
import { Fragment, useEffect, useState } from "react";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import { useDispatch, useSelector } from "react-redux";

const SalaryTemplates = ({ drawer }) => {
  const { Title } = Typography;
  const { Option } = Select;
  const [loader, setLoader] = useState(false);
  const [form] = Form.useForm();
  const [earnings, setEarnings] = useState([]);
  const [deductions, setDeductions] = useState([]);
  const [templateName, setTemplateName] = useState("");
  const [description, setDescription] = useState("");
  const [ctc, setCtc] = useState("");

  const addSalaryTemplate = async (values) => {
    try {
      await axios({
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `setting/addSalaryTemplate`,
        data: {
          ...values,
          earnings: earnings,
          deductions: deductions,
          ctc: ctc,
        },
      });
      return "success";
    } catch (error) {
      // console.log(error.message);
    }
  };

  const onFinish = async (values) => {
    try {
      const resp = await addSalaryTemplate(values);
      if (resp === "success") {
        toast.success("Salary Template Added Successfully");
        form.resetFields();
        setEarnings([]);
        setDeductions([]);
        setTemplateName("");
        setDescription("");
        setCtc("");
      }
    } catch (error) {
      // console.log(error.message);
    }
  };

  const onFinishFailed = (errorInfo) => {
    toast.warning("Failed to add salary template");
    setLoader(false);
  };

  return (
    <Fragment>
      <UserPrivateComponent permission={"create-setting"}>
        <Row className="mr-top" justify={drawer ? "center" : "space-between"}>
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={drawer ? 22 : 16}
            xl={drawer ? 22 : 12}
            className="column-design border rounded card-custom"
          >
            <Title level={4} className="m-2 mt-5 mb-5 text-center">
              Salary Template
            </Title>

            <Form
              form={form}
              style={{ marginBottom: "40px" }}
              eventKey="template-form"
              name="salaryTemplateForm"
              labelCol={{
                span: 8,
              }}
              wrapperCol={{
                span: 12,
              }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <div>
                <Form.Item
                  style={{ marginBottom: "10px" }}
                  label="Template Name"
                  name="templateName"
                  rules={[
                    {
                      required: true,
                      message: "Please input the template name!",
                    },
                  ]}
                >
                  <Input onChange={(e) => setTemplateName(e.target.value)} />
                </Form.Item>
                <Form.Item
                  style={{ marginBottom: "10px" }}
                  label="Description"
                  name="description"
                >
                  <Input.TextArea
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </Form.Item>
                <Form.Item
                  style={{ marginBottom: "10px" }}
                  label="CTC (Cost To Company)"
                  name="ctc"
                  rules={[
                    {
                      required: true,
                      message: "Please input the CTC!",
                    },
                  ]}
                >
                  <Input
                    type="number"
                    onChange={(e) => setCtc(e.target.value)}
                  />
                </Form.Item>
                <Form.Item
                  style={{ marginBottom: "10px" }}
                  label="Earnings"
                  name="earnings"
                >
                  <Select
                    mode="multiple"
                    placeholder="Select earnings"
                    onChange={(value) => setEarnings(value)}
                  >
                    {/* Option items for earnings */}
                  </Select>
                </Form.Item>
                <Form.Item
                  style={{ marginBottom: "10px" }}
                  label="Deductions"
                  name="deductions"
                >
                  <Select
                    mode="multiple"
                    placeholder="Select deductions"
                    onChange={(value) => setDeductions(value)}
                  >
                    {/* Option items for deductions */}
                  </Select>
                </Form.Item>
                <Form.Item
                  style={{ marginBottom: "10px" }}
                  wrapperCol={{
                    offset: 8,
                    span: 12,
                  }}
                >
                  <Button
                    type="primary"
                    htmlType="submit"
                    size="large"
                    block
                    loading={loader}
                  >
                    Add Salary Template
                  </Button>
                </Form.Item>
              </div>
            </Form>
          </Col>
        </Row>
      </UserPrivateComponent>
    </Fragment>
  );
};

export default SalaryTemplates;

